import { Component, OnInit } from '@angular/core';
import { ModalController } from "@ionic/angular";
import { NavParams, PickerController } from '@ionic/angular';
import { PickerOptions } from '@ionic/core';
import { AppService } from './../../app.service';
import moment from "moment";

@Component({
  selector: 'app-fasting-alarm-popup',
  templateUrl: './fasting-alarm-popup.component.html',
  styleUrls: ['./fasting-alarm-popup.component.scss'],
})
export class FastingAlarmPopupComponent implements OnInit {

  startedFasting: boolean = false;
  onFast: boolean = false;
  fromTimeFasting;
  selectedIneterval;
  fastDuration;
  endTimeFasting;
  minTime;
  maxTime;
  intervalSection = [
    // { text: '2 mins', value: 2},
    // { text: '30 mins', value: 30},
    { text: '12 hour', value: 12 },
    { text: '13 hours', value: 13 },
    { text: '14 hours', value: 14 },
    { text: '15 hours', value: 15 },
    { text: '16 hours', value: 16 }
  ];

  constructor(
    private modalController: ModalController,
    private navParams: NavParams,
    private pickerCtrl: PickerController,
    private appService: AppService

  ) {
    this.onFast = this.navParams.get('onFast');
    this.fastDuration = Number(this.navParams.get('fastDuration'));
  }

  ngOnInit() { }

  ionViewWillEnter() {
    this.selectedIneterval = this.intervalSection[2];
    this.fromTimeFasting = this.endTimeFasting = new Date().toISOString();
    this.minTime="00:01";
    this.maxTime = new Date().getHours() + ":" + moment(new Date()).format("mm");
  }

  // changeTime(type) {
  //   // if (type == 'from') {
  //   //   this.fromTimeFasting = new Date(this.fromTimeFasting).toISOString();
  //   // }
  // }

  changeTime(event, isFastingEnd){
    if(isFastingEnd){
      this.endTimeFasting = new Date(event.detail.value).toISOString();
    }
    this.fromTimeFasting = new Date(event.detail.value).toISOString();
  }

  async selectTimeRange() {
    let self = this;
    let opts: PickerOptions = {
      mode: 'ios',
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        { text: 'Done' }
      ],
      columns: [
        { name: 'Interval', options: this.intervalSection,  }
      ]
    };
    let picker = await this.pickerCtrl.create(opts);
    picker.present();
    picker.onDidDismiss().then(data => {
      self.selectedIneterval = data.data["Interval"];
    });
  }

  async startFasting() {
    this.onFast = true;
    const startTime = moment(this.fromTimeFasting);
    localStorage.setItem("onFast", this.onFast.toString());
    localStorage.setItem("fastDate", moment(startTime).format('DDMMYYYY'));
    localStorage.setItem("fastStartTime", this.fromTimeFasting.toString());
    localStorage.setItem("fastDuration", this.fastDuration.toString());

    this.modalController.dismiss({ 'onFast': this.onFast, 'startTime': startTime, "interval": this.fastDuration });

    let reqBody = {
      "date": moment(startTime).format('DDMMYYYY'),
      "startTime": moment(startTime).format("hh:mm:ss"),
      "endTimeFasting": moment(startTime).add(this.fastDuration, "hours").format("hh:mm:ss"),
      "interval": this.fastDuration
    };
    let reqBody1 = {
        "date": moment(startTime).format('DDMMYYYY'),
        "duration": this.fastDuration,
        "endTime":moment(startTime).add(this.fastDuration, "hours").format("hh:mm:ss"),
        "startTime":moment(startTime).format("hh:mm:ss")
    };

   let savedFasting =   await this.appService.postSaveFastingDetails(reqBody);
   if(savedFasting){
    await this.appService.saveFasting(reqBody1);
   }
    
  }

  endFasting(fasting) {
    if (fasting) {
      let startTimeData = localStorage.getItem("fastStartTime") || undefined;
      const endTimeFasting = moment(this.endTimeFasting);

      localStorage.removeItem("onFast");
      localStorage.removeItem("fastDate");
      localStorage.removeItem("fastStartTime");
      localStorage.removeItem("fastDuration");

      this.modalController.dismiss({ 'onFast': false, 'startTime': undefined, "interval": undefined });

      let reqBody = {
        "date": moment(startTimeData).format('DDMMYYYY'),
        "startTime": moment(startTimeData).format("hh:mm:ss"),
        "endTimeFasting": moment(endTimeFasting).format("hh:mm:ss"),
        "interval": this.fastDuration
      };
      this.appService.postSaveFastingDetails(reqBody).catch(e => {
        this.onFast = false;
        console.error(e);
      });
    } else {
      this.close();
    }
  }

  close() {
    this.modalController.dismiss();
  }
}
